// // src/components/DataDisplay.js

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import Map, { Marker } from 'react-map-gl';
// import 'mapbox-gl/dist/mapbox-gl.css';
// import logo from '../assets/logo.jpg'; // Убедитесь, что путь к изображению правильный
// import '../styles/Card.css'; // Ваши стили

// const DataDisplay = () => {
//   const [data, setData] = useState([]);
//   const [viewStates, setViewStates] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Standorte';
//   const MAPBOX_TOKEN =
//     process.env.REACT_APP_MAPBOX_TOKEN ||
//     'pk.eyJ1IjoibGV5cHVzLWNvZGUiLCJhIjoiY2x1bXAwdmh6MGEyMTJrcG54djk0bDJjeiJ9.lZe5s7XCNn3dndXXl66Naw';

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(API_URL);
//         if (response.data && response.data.data) {
//           setData(response.data.data);

//           // Инициализируем viewStates для каждой карты
//           const initialViewStates = {};
//           response.data.data.forEach((item) => {
//             const { id, Standort } = item;
//             if (Standort && Standort.coordinates) {
//               initialViewStates[id] = {
//                 latitude: Standort.coordinates[1],
//                 longitude: Standort.coordinates[0],
//                 zoom: 14,
//                 pitch: 65, // Добавляем pitch для похожего вида, как в примере Map.js
//                 bearing: 0,
//               };
//             }
//           });
//           setViewStates(initialViewStates);
//         } else {
//           setError('Нет данных для отображения');
//         }
//       } catch (err) {
//         setError('Ошибка при получении данных');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [API_URL]);

//   // Обработчик изменения состояния карты
//   const handleViewStateChange = (id, newViewState) => {
//     setViewStates((prevViewStates) => ({
//       ...prevViewStates,
//       [id]: {
//         ...prevViewStates[id],
//         ...newViewState,
//       },
//     }));
//   };

//   if (loading) return <div>Загрузка...</div>;
//   if (error) return <div>{error}</div>;

//   return (
//     <div>
//       {data.map((item) => {
//         const { id, Name, Adresse, Standort, Zeitplan } = item;

//         // Проверяем наличие координат
//         if (!Standort || !Standort.coordinates) {
//           return (
//             <div key={id} className="location-card">
//               <h2>{Name}</h2>
//               <p>{Adresse}</p>
//               <p>Координаты не найдены</p>
//             </div>
//           );
//         }

//         const coordinates = Standort.coordinates; // [долгота, широта]

//         // Формируем ссылку на Google Maps
//         const latitude = coordinates[1];
//         const longitude = coordinates[0];
//         const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

//         return (
//           <div key={id} className="location-card">
//             <h2>{Name}</h2>
//             <p className="map-address">{Adresse}</p>

//             <div className="schedule">
//               <h3>Öffnungszeiten</h3>
//               {Zeitplan && (
//                 <div
//                   className="schedule-content"
//                   dangerouslySetInnerHTML={{ __html: Zeitplan }}
//                 />
//               )}
//             </div>

//             <a
//               style={{ textDecoration: 'none' }}
//               href={googleMapsLink}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <div className="karte-link">Karte & Anfahrt</div>
//             </a>

//             <div style={{ width: '100%', height: '200px', marginBottom: '20px' }}>
//               <Map
//                 {...viewStates[id]}
//                 onMove={(evt) => handleViewStateChange(id, evt.viewState)}
//                 mapboxAccessToken={MAPBOX_TOKEN}
//                 mapStyle="mapbox://styles/mapbox/streets-v11"
//                 style={{ width: '100%', height: '100%' }}
//               >
//                 <Marker latitude={coordinates[1]} longitude={coordinates[0]} anchor="bottom">
//                   <div style={{ position: 'relative', width: '50px', height: '60px' }}>
//                     <img
//                       src={logo}
//                       alt="Logo"
//                       style={{
//                         width: '70px',
//                         height: '30px',
//                         objectFit: 'cover',
//                         borderRadius: '8px',
//                         boxShadow: '0 0 5px rgba(0,0,0,0.3)',
//                         position: 'absolute',
//                         top: '19px',
//                         left: '50%',
//                         transform: 'translateX(-50%)',
//                       }}
//                     />

//                     <div
//                       style={{
//                         position: 'absolute',
//                         bottom: '-1px',
//                         left: '50%',
//                         width: '0',
//                         height: '0',
//                         borderLeft: '25px solid transparent',
//                         borderRight: '25px solid transparent',
//                         borderTop: '12px solid #f39200',
//                         transform: 'translateX(-50%)',
//                       }}
//                     ></div>
//                   </div>
//                 </Marker>
//               </Map>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default DataDisplay;



// src/components/MapsGrid.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Map, { Marker } from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import logo from '../assets/logo_blau.svg';
import telIcon from '../assets/tel_icon.svg';
import emailIcon from '../assets/mail_icon.svg';
import '../styles/Card.css'; // Ваши стили
import MouseTooltip from '../MouseTooltip'; // Ваш анимированный компонент с мышкой

const MapsGrid = () => {
  const [data, setData] = useState([]);
  const [viewStates, setViewStates] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Чтобы показывать/скрывать мышку на каждой конкретной карте,
  // введём стейт hoveredMapId.
  const [hoveredMapId, setHoveredMapId] = useState(null);

  // Ваш ключ для Mapbox
  const MAPBOX_TOKEN =
    process.env.REACT_APP_MAPBOX_TOKEN ||
    'pk.eyJ1IjoibGV5cHVzLWNvZGUiLCJhIjoiY2x1bW94Yno1MTdkZjJrcGhxMm1iZmE0MiJ9.dxFto8ElL_Auwbex9FHmeg';

  // Адрес к вашему API
  const API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Standorte?fields=*.*&filter[status][_eq]=published';

  // При монтировании компонента получаем данные и инициализируем viewState.
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL);
        if (response.data && response.data.data) {
          const standorte = response.data.data;
          setData(standorte);

          const initialViewStates = {};
          standorte.forEach((item) => {
            const { id, Standort } = item;
            if (Standort && Standort.coordinates) {
              initialViewStates[id] = {
                latitude: Standort.coordinates[1],
                longitude: Standort.coordinates[0],
                zoom: 14,
                pitch: 65,
                bearing: 0,
              };
            }
          });
          setViewStates(initialViewStates);
        } else {
          setError('Fehler beim Laden der Standorte');
        }
      } catch (err) {
        setError('Fehler beim Laden der Standorte');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_URL]);

  // Сохраняем обновлённые координаты/масштаб в стейт при перемещении карты.
  const handleViewStateChange = (id, newViewState) => {
    setViewStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        ...newViewState,
      },
    }));
  };

  if (loading) return <div>Wird geladen...</div>;
  if (error) return "";

  return (
    <div className="app-wrapper">
      {/* <div className="map-container">
        <h1>Deine Fahrschule mit Drive <span>Optimale Lernbedingungen für deinen Führerschein.</span></h1>
        <p>Bei uns wird aus trockener Theorie ein spritziges Fahrerlebnis. In unseren modernen Räumen und mit unserem top-motivierten Team bist du bestens vorbereitet – und hast dabei auch noch Spaß. Melde dich jetzt an und starte durch!</p>
      </div> */}
      <div className="map-container">
        <h1>Deine Fahrschule mit Drive <span>O wie Orange Drivers, O wie optimale Lernumgebung!</span></h1>
        <p>Bei uns wird aus trockener Theorie ein spritziges Fahrerlebnis. In unseren modernen Räumen und mit unserem top-motivierten Team bist du bestens vorbereitet – und hast dabei auch noch Spaß. Melde dich jetzt an und starte durch!</p>
      </div>
      {/* <div className="map-container">
        <h1>Welcome to the set!</h1>
        <p>Dein Führerschein beginnt nicht erst auf der Straße. Moderne Lehrsäle, coole PC-Räume und eine Atmosphäre zum Wohlfühlen, bei Steinmetz ist alles bereit für deinen großen Auftritt.</p>
        <p>Take your seat. Let’s start.</p>
      </div> */}
      
      {data.map((item) => {
        const {
          id,
          Name,
          Adresse,
          Bilder,
          Standort,
          Zeitplan,
          Telefon,
          EMail,
          GoogleLink,
        } = item;

        // Проверяем наличие координат
        if (!Standort || !Standort.coordinates) {
          return (
            <div key={id} className="location-card">
              <h2>{Name}</h2>
              <p>{Adresse}</p>
              <p>{Telefon}</p>
              <p>{EMail}</p>
              <p>Koordinaten nicht gefunden</p>
            </div>
          );
        }

        // Внимание! В GeoJSON порядок координат: [долгота, широта]
        const [longitude, latitude] = Standort.coordinates;
        const googleMapsLink = GoogleLink;

        return (
          <div key={id} className="location-card">
            <div className="location-content">
              <h2>{Name}</h2>
              <p className="map-address">{Adresse}</p>
              {Telefon && (
                <a className="map-telefon" href={`tel:${Telefon}`}>
                  <img src={telIcon} alt={`${Telefon} anrufen`} />
                  {Telefon}
                </a>
              )}
              {EMail && (
                <a className="map-email" href={`mailto:${EMail}`}>
                  <img src={emailIcon} alt={`E-Mail an ${EMail} senden`} />
                  {EMail}
                </a>
              )}
              {Zeitplan && (
              <div className="schedule">
                <h3>Öffnungszeiten</h3>
                  <div
                    className="schedule-content"
                    dangerouslySetInnerHTML={{ __html: Zeitplan }}
                  />
              </div>
              )}
            </div>

            {/* 
              Оборачиваем карту в контейнер, где следим за onMouseEnter / onMouseLeave.
              Если мы навели курсор, запоминаем id, чтобы показывать анимированную мышку.
            */}
            <div
              className="map"
              style={{ position: 'relative' }}
              onMouseEnter={() => setHoveredMapId(id)}
              onMouseLeave={() => setHoveredMapId(null)}
            >
              {/* Если именно эта карта в hover, показываем анимированную мышку */}
              {hoveredMapId === id && (
                <div
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    zIndex: 999,
                  }}
                >
                  <MouseTooltip />
                </div>
              )}

              <Map
                {...viewStates[id]}
                onMove={(evt) => handleViewStateChange(id, evt.viewState)}
                mapboxAccessToken={MAPBOX_TOKEN}
                mapStyle="mapbox://styles/mapbox/streets-v11"
                style={{ width: '100%', height: '100%' }}
              >
                <Marker latitude={latitude} longitude={longitude} anchor="bottom">
                  <div
                    style={{
                      position: 'relative',
                      width: '48px',
                      height: '48px',
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="var(--primary)"><path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-80Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Z"/></svg>
                    {/* <img
                      src={logo}
                      alt="Logo"
                      style={{
                        width: '70px',
                        height: '30px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        boxShadow: '0 0 5px rgba(0,0,0,0.3)',
                        position: 'absolute',
                        top: '19px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                      }}
                    /> */}
                    {/* <div
                      style={{
                        position: 'absolute',
                        bottom: '-1px',
                        left: '50%',
                        width: '0',
                        height: '0',
                        borderLeft: '1rem solid transparent',
                        borderRight: '1rem solid transparent',
                        borderTop: '2rem solid #f39200',
                        transform: 'translateX(-50%)',
                      }}
                    ></div> */}
                  </div>
                </Marker>
              </Map>
            </div>

            <a
              className="map-link"
              href={googleMapsLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="karte-link">Karte & Anfahrt</div>
            </a>

            {Bilder.length > 0 && (
              <div className="location-gallery">
                <div className="gallery-container">
                  {Bilder?.map((image) => {
                    const imageUrl = `${process.env.REACT_APP_API_BASE_URL}/assets/${image.directus_files_id}.jpg`;
                    return (
                      <img
                        key={image.directus_files_id}
                        className="location-image"
                        src={imageUrl}
                        alt={image.directus_files_id || "Media"}
                      />
                    )
                  })}
                </div>
              </div>
            )} 
          </div>
        );
      })}
    </div>
  );
};

export default MapsGrid;


